<template>
  <div class="container" v-if="contents.length">
    <div class="row width_full mt_20 pt_20 mb_20 pb_20" >
      <div class="col_12">
        <div class="d_flex_btwn">
          <h2>Users Contents</h2>
        </div>
      </div>
      <div class="col_12 mt_15">
        <div class="customer_content">
          <table-component
              :columns="columns"
              :rows="contents"
              :header="true"
              :centralized="true"
              :sortable="sortable"
              :pagination="pagination"
              :searchShowStatus="false"
              :perPageShowStatus="false"
              @sorting="sorting"
              @pageChanged="pageChanged">
            <template v-slot:file="{ row }">
              <a v-if="row.file" class="color_blue item_size_delete cursor_pointer" :href="row.file"   target="_blank" download>
                {{ fileNameSlice(row.file) }}
              </a>
            </template>
            <template v-slot:action="{ row }">
              <span class="ml_10 btn btn_blue cursor_pointer" @click="editRow(row)">Edit</span>
              <span class="ml_10 btn btn_danger cursor_pointer" @click="deleteRecord(row)">Delete</span>
            </template>
          </table-component>
        </div>
      </div>
    </div>
    <modal-component
        v-if="showModal"
        :modal-size="'custom_modal_1200p'"
        :header-classes="'display_table white_bg no_border pa15 pb_0'"
        :content-classes="'pl_15 pr_15'"
        @closeModal="closeModal"
    >
      <template #header>
        <span class="modal_header_title">{{ modalForm ? modalForm.name : ''}}</span>
      </template>
      <template #content>
        <div class="row">
          <div class="col_4">
            <div :class="['form-group', {'has_error': errorFor('name')}]">
              <label class="required">Name</label>
              <input type="text" class="form_global" placeholder="Title" v-model="modalForm.name">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>



          <div class="col_4">
            <div :class="['form-group', {'has_error': errorFor('file')}]">
              <label>File</label>
              <input type="file" class="form_global" ref="imageInput" @input="onFileChange($event, 'file')">
              <template v-if="errors && errors.file">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.file" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div  class="width_full" v-if="row.file">
              <div class="p_relative d_flex_btwn">

                <div class="cross_ic " @click="removeVideo('file')"> <i class='bx bx-x'></i> </div>
                <i class="fas fa-file-invoice ml_20 font_16p"></i>
              </div>
            </div>
          </div>

          <div class="col_4">
            <div :class="['form-group', {'has_error': errorFor('image')}]">
              <label>Image</label>
              <input type="file" class="form_global" ref="imageInput" @input="onFileChange($event, 'image')">
              <template v-if="errors && errors.image">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.image" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div  class="width_full" v-if="row.image">
              <div class="p_relative">
                <img :src="row.image" alt="" width="100">
                <div class="cross_ic" @click="removeVideo('image')"> <i class='bx bx-x'></i> </div>
              </div>
            </div>
          </div>

          <div class="col_8">
            <div class="form-group">
              <label>video </label>
              <div class="create_images_area dropzone p_0" :class="[{'has_error': errorFor('video')}]">
                <div class="create_images">
                  <div class="file_input">

                  </div>
                  <template v-if="dropzonError">
                    <small class="d_flex_start text_danger" :key="'error_video_'">{{dropzonError}}</small>
                  </template>
                </div>
                <div class="dropzone-video-previews">
                </div>
                <div class="dropzone_wrap">
                  <div class="create_images_drag dropzone-video-clickable dropzone-video-container">
                    <div class="images">
                      <span>Drag & Drop Video from your computer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col_4 mt_10" v-if="row.video">
            <div class="display_inline d_flex_start p_relative mt_20" >
              <video class="width_full" controls autoplay muted>
                <source :src="row.video" type="video/mp4">
                Your browser does not support HTML5 video.
              </video>
              <span class="close_icon p_absolute" style="cursor: pointer;color: red;" @click="removeVideo('video')"></span>
            </div>
          </div>
          <div class="col_12">
            <div :class="['form-group', {'has_error': errorFor('description')}]">
              <label>Description</label>
              <text-editor v-model:text="modalForm['description']" :id="'description2'"></text-editor>
              <template v-if="errors && errors.description">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.description" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_12">
            <div class="d_flex_end">
              <button class="btn btn_common" @click.prevent="submitContentForm">save <i v-if="loading" class="fas fa-circle-notch fa-spin ml_5"></i></button>
            </div>
          </div>
        </div>
      </template>
    </modal-component>
  </div>
</template>

<script>
import TableComponent from "../../../components/shared/TableComponent";
import ModalComponent from "../../../components/shared/ModalComponent";
import Dropzone from "dropzone";
import 'dropzone/dist/dropzone.css'
import TextEditor from "../../../components/shared/TextEditor";
export default {
  name: "UserContentTemplate",
  components: {TextEditor, ModalComponent, TableComponent},
  data(){
    return {
      dropzonError: '',
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true
        },

        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      showModal: false,
      modalForm:{
        name: '',
        page_id: this.$route.params.id,
        image: '',
        file: '',
        video: '',
        description: ''
      },
      progress: null,
      row: null,

      contents: [],
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'name',
        sort: '',
        sort_order: '',
        page_type: this.$route.params.type,
        page_id:this.$route.params.id
      },
      sort: '1',
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
    }
  },
  created() {
    this.loadContent();
  },
  methods:{
    fileNameSlice(text){
      if(text && typeof text === 'string') {
        let row = text.split('/')
        return row[row.length - 1];
      }
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    loadContent(){
      this.axios.get('/user-contents', {params:{...this.queryParams}})
          .then((response) => {
            this.contents = response.data.data
            this.pagination = response.data.meta;
          })
    },
    onFileChange(event, column){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]

      this.modalForm[column] = file
      this.row[column] = URL.createObjectURL(file);
    },
    editRow(row){
      this.row = row
      this.modalForm.name = row.name
      this.modalForm.description = row.description
      this.showModal = true

      setTimeout(()=>{
        this.initDropZon()
      }, 100)
    },
    closeModal(){
      this.showModal = false
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/user-contents/'+row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Contents has been deleted!',
                'success'
            )
            this.loadContent();
          });
        }
      });
    },
    removeVideo(type) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/file-delete/user-data-room/'+this.row.id, {params:{type:type}}).then(() => {
            this.$swal.fire(
                'Deleted',
                'Contents has been deleted!',
                'success'
            )
            this.row[type] = null
          });
        }
      });
    },
    initDropZon(){
      let that = this;
      const user = JSON.parse(localStorage.getItem('admin'))|| null
      new Dropzone(".dropzone-video-container", {
        clickable: '.dropzone-video-clickable',
        disablePreviews: false,
        createImageThumbnails: true,
        allowMultiple: false,
        addRemoveLinks: true,
        autoProcessQueue: true,
        acceptedFiles: 'video/mp4,.mkv,.avi,.flv,.mov,.wmv,.3gp,.webm,audio/mp3',
        chunking: true,
        chunkSize: 15000000,
        previewsContainer: '.dropzone-video-previews',
        maxFiles: 1,
        maxFilesize: 3000000000,

        headers: {
          'Authorization': `Bearer ${user.token}`
        },
        url: (process.env.VUE_APP_API_BASE_URL + '/temp-file-upload'),
        success: function (file, response) {
          that.modalForm.video = ''
          setTimeout(() => {
            that.modalForm.video = response.draft;
          }, 200);
        },
        error: function (file, response) {
          that.dropzonError = response
        },
      });
    },
    async submitContentForm(){
      this.errors = null;
      this.loading = true;
      this.progress = null

      let formData = new FormData()

      Object.keys(this.modalForm).forEach(key => {
        formData.append(key, this.modalForm[key] ? this.modalForm[key] : '');
      })
      formData.append('_method','PATCH')
      await this.axios.post('/user-contents/'+this.row.id, formData, {
        onUploadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        },
      })
          .then(() => {
            this.errors = null;
            this.row = null;
            this.showModal = false;
            this.loadContent()

            this.showSuccessMsg("Added Successfully!");
          })
          .catch((err) => {
            this.errors = err.response.data.errors
          })
          .finally(() => {
            this.loading = false;
            this.progress = null
          })
    },
  }
}
</script>

<style scoped>

</style>